// Royalty-free ambient music synthesized live with Web Audio (pads + chimes)
const PAD_CHORDS = [
  [110, 164.81, 220, 277.18],
  [98, 146.83, 196, 246.94],
  [87.31, 130.81, 174.61, 220],
  [103.83, 155.56, 207.65, 261.63],
];
const CHIME_NOTES = [440, 523.25, 659.25, 783.99, 880, 1046.5];

export function createMysticMusic() {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const master = ctx.createGain();
  master.gain.value = 0;
  const delay = ctx.createDelay(2);
  delay.delayTime.value = 0.45;
  const feedback = ctx.createGain();
  feedback.gain.value = 0.45;
  delay.connect(feedback).connect(delay);
  delay.connect(master);
  master.connect(ctx.destination);

  let chordIdx = 0;
  const timers = [];
  // Start the pad straight away once the browser lets sound play.
  ctx.addEventListener("statechange", () => {
    if (ctx.state === "running" && timers.length) playChord();
  });

  const playChord = () => {
    if (ctx.state !== "running") return; // notes queued while suspended would all burst out on resume
    const now = ctx.currentTime;
    PAD_CHORDS[chordIdx % PAD_CHORDS.length].forEach((f) => {
      [-4, 4].forEach((detune) => {
        const osc = ctx.createOscillator();
        const g = ctx.createGain();
        const lp = ctx.createBiquadFilter();
        osc.type = "sawtooth";
        osc.frequency.value = f;
        osc.detune.value = detune;
        lp.type = "lowpass";
        lp.frequency.value = 700;
        g.gain.setValueAtTime(0, now);
        g.gain.linearRampToValueAtTime(0.025, now + 2.5);
        g.gain.linearRampToValueAtTime(0, now + 8.5);
        osc.connect(lp).connect(g).connect(master);
        g.connect(delay);
        osc.start(now);
        osc.stop(now + 9);
      });
    });
    chordIdx++;
  };

  const playChime = () => {
    if (ctx.state !== "running") return;
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = CHIME_NOTES[Math.floor(Math.random() * CHIME_NOTES.length)];
    g.gain.setValueAtTime(0, now);
    g.gain.linearRampToValueAtTime(0.06, now + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, now + 3);
    osc.connect(g).connect(master);
    g.connect(delay);
    osc.start(now);
    osc.stop(now + 3.2);
  };

  return {
    chime() {
      const now = ctx.currentTime;
      const out = ctx.createGain();
      out.gain.value = 1;
      out.connect(ctx.destination);
      [659.25, 987.77, 1318.5].forEach((f, i) => {
        const osc = ctx.createOscillator();
        const g = ctx.createGain();
        osc.type = "sine";
        osc.frequency.value = f;
        g.gain.setValueAtTime(0, now);
        g.gain.linearRampToValueAtTime(0.09 / (i + 1), now + 0.03);
        g.gain.exponentialRampToValueAtTime(0.0001, now + 3.5);
        osc.connect(g).connect(out);
        osc.start(now);
        osc.stop(now + 3.6);
      });
    },
    unlock() {
      return ctx.resume();
    },
    isRunning() {
      return ctx.state === "running";
    },
    start() {
      ctx.resume();
      if (timers.length) return;
      master.gain.cancelScheduledValues(ctx.currentTime);
      master.gain.setValueAtTime(master.gain.value, ctx.currentTime);
      master.gain.linearRampToValueAtTime(0.8, ctx.currentTime + 1.5);
      playChord();
      playChime();
      timers.push(setInterval(playChord, 7000));
      timers.push(setInterval(playChime, 1300));
    },
    fadeOut(seconds = 2) {
      const t = ctx.currentTime;
      master.gain.cancelScheduledValues(t);
      master.gain.setValueAtTime(master.gain.value, t);
      master.gain.linearRampToValueAtTime(0, t + seconds);
      setTimeout(() => {
        timers.forEach(clearInterval);
        timers.length = 0;
      }, seconds * 1000);
    },
    setMuted(m) {
      ctx.resume();
      if (m) ctx.suspend();
    },
    close() {
      timers.forEach(clearInterval);
      ctx.close();
    },
  };
}
